<div #globalSearch
    (click)="showSearchPanel()"
    [(nTooltipVisible)]="visible"
    [nTooltipDisabled]="size!=='small'"
    [nTooltip]="globalSearchPanel"
    [ngClass]="{ 'global-search': true, active:size === 'small' ? visible :infigo.visible }"
    nTooltipOverlayClass="global-search-panel"
    nTooltipPlacement="left"
    nTooltipTheme="black"
    nTooltipTrigger="click">
    <!-- 初次登录时提示信息绑定origin -->
    <svg [nTooltip]="showTips"
        [ngClass]="{ icon: true, 'header-icon': true }"
        nTooltipPlacement="left"
        nTooltipTheme="white">
        <use *ngIf="size === 'small' ? visible : infigo.visible; else defaultUse"
            xlink:href="#app-icon-header-search-focus"></use>
    </svg>
    <ng-template #defaultUse>
        <svg>
            <use xlink:href="#app-icon-header-search-new"></use>
        </svg>
    </ng-template>
</div>

<!-- 初次登录时提示信息 -->
<infigo-base #infigoComponent
    [providers]="providers"></infigo-base>
<ng-template #showTips>
    <div class="global-search-show-tips">{{ i18n.tips }}</div>
</ng-template>

<!-- globalSearch下拉面板 -->
<ng-template #globalSearchPanel>
    <ng-container *ngIf="loading">
        <div class="global-search-loading">{{ i18n.loading }}</div>
    </ng-container>
    <ng-container *ngIf="!loading">
        <app-global-search-input #searchInput
            (searchResultChange)="searchResultChange($event)"
            [baseCount]="baseCount"
            [initValue]="inputValue"
            [onSwitchSize]="switchSize"></app-global-search-input>
        <app-global-search-list #searchList
            (viewMoreClick)="viewMore()"
            (viewPageChange)="viewPageChange()"
            [baseCount]="baseCount"
            [data]="searchResult"
            [inputValue]="inputValue"
            [more]="more"></app-global-search-list>
    </ng-container>
</ng-template>
<ng-template #GlobalSearchTemplateRef
    let-choose="choose"
    let-data
    let-input="input">
    <div [ngClass]="{
    'base-template':true,
    'choose':choose
    }">
        <div class="flex-start">
            <svg [nTooltip]="data.objectDes"
                class="icon"
                nTooltipPlacement="top">
                <use [attr.xlink:href]="iconType[data.type]"></use>
            </svg>
            <div class="title-group">
                <div [innerHTML]="service.getHighLight(data.name,input, '#2b2332', choose)"
                    nTextTips
                    nTextTipsPlacement="top"></div>
                <div class="vstore-info">
                    <!-- 微存储屏蔽多租户-->
                    <span *ngIf="data.vstoreName && FeatureConfig.IsSupportVStoreService"
                        nTextTips
                        nTextTipsPlacement="bottom">
                        <svg class="icon">
                            <use xlink:href="#infigo-solid-vStore"></use>
                        </svg>
                        {{data.vstoreName }}</span>
                    <span *ngIf="data.vstoreName && FeatureConfig.IsSupportVStoreService"
                        class="no-shrink line-inline"
                    >|</span>
                    <span [ngClass]="{'vstore-des': data.vstoreName, 'no-shrink': data.vstoreName}"
                        nTextTips
                        nTextTipsPlacement="top">{{data.objectDes}}</span>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #ConditionTemplateRef
    let-choose="choose"
    let-data>
    <div [ngClass]="{
        'base-template':true,
        'condition':true,
        'choose':choose
    }">
        <div class="flex-start">
            <svg [nTooltip]="data.objectDes"
                class="icon"
                nTooltipPlacement="top">
                <use [attr.xlink:href]="iconType[data.type]"></use>
            </svg>
            <div class="title-group">
                <div nTextTips nTextTipsPlacement="top">{{data.name}}</div>
                <div class="vstore-info">
                    <!-- 微存储屏蔽多租户-->
                    <span *ngIf="data.vstoreName && FeatureConfig.IsSupportVStoreService"
                        nTextTips
                        nTextTipsPlacement="bottom">
                        <svg class="icon">
                            <use xlink:href="#infigo-solid-vStore"></use>
                        </svg>
                        {{data.vstoreName }}</span>
                    <span *ngIf="data.vstoreName && FeatureConfig.IsSupportVStoreService" class="no-shrink line-inline">|</span>
                    <span [ngClass]="{'vstore-des': data.vstoreName, 'no-shrink': data.vstoreName}"
                        nTextTips
                        nTextTipsPlacement="top">
                        {{ data | condition:conditionP.preValue }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #alarmTemplateRef
    let-data>
    <div class="line-one">
        <span class="alarm-level-icon">
            <svg class="icon">
                <use [attr.xlink:href]="levelIcon[data.item.level]"></use>
            </svg>
        </span>
        <span class="description" innerHTML="{{data.item.description}}"></span>
    </div>
    <p class="alarm-date">{{ getTimeString(data.item.startTime * 1e3) }}</p>
</ng-template>
<ng-template #loadingTemplateRef let-loading>
    <n-loading [visible]="true"></n-loading>
</ng-template>
<ng-template #helpTemplateRef let-item let-input="input">
    <div class="global-search-help-item">
        <infigo-highlight [appHighlightStr]="input||'' " [appWholeStr]="item.name||''"></infigo-highlight>
        <div class="item-path">{{ item.path }}</div>
    </div>
</ng-template>
